import React from 'react'
import TitleTopic from '../../components/TitleTopic'
import Text from '../../components/Text'
import configOptions from './modules/config-options'
import translate from '../../modules/translate'
import ContainerArticle from '../../components/ContainerArticle'
import OptionsAccordion from './components/OptionsAccordion'
import { useUserContext } from '../../components/ContextUser'
import LayoutDefault from '../../layouts/Default'

const DlabSettings = ({ location, match, layout, ...props }) => {
  const meta = {
    adsTargeting: {
      STOL7_seite: 'DlabSettings',
    },
    robots: 'noindex, nofollow',
  }

  const {
    access: { isStandard },
    profil,
  } = useUserContext()

  let showSettings = false
  if (profil !== undefined && profil != null && profil.roles && profil.roles.includes('admin')) {
    showSettings = true
  }
  console.log(configOptions)
  return (
    <LayoutDefault disable={!layout} meta={meta} showAds={false} {...props}>
      <TitleTopic title={'Einstellungen'} />
      <ContainerArticle>
        {showSettings && <OptionsAccordion options={configOptions()} />}

        {!showSettings && (
          <Text>
            <h4>{translate('authorisation_message')}</h4>
          </Text>
        )}
      </ContainerArticle>
    </LayoutDefault>
  )
}

DlabSettings.defaultProps = {
  layout: true,
}

export default DlabSettings
